import { useAutoPauseSmsWithReminder } from './use-auto-pause-sms-with-reminder';

export const useAutoPauseReminderPreferences = () => {
  useAutoPauseSmsWithReminder();
};
